import { render } from "./HomeFAQ.vue?vue&type=template&id=6eb2e4ec"
import script from "./HomeFAQ.vue?vue&type=script&lang=js"
export * from "./HomeFAQ.vue?vue&type=script&lang=js"

import "./HomeFAQ.vue?vue&type=style&index=0&id=6eb2e4ec&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__